var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
    {
      'box-layout': _vm.boxLayout,
      'collapse-sidebar': _vm.collapseSidebar
    }
  ],attrs:{"id":"inspire"}},[_c('router-view'),_vm._v(" "),_vm._l((_vm.stickerMemoList),function(memo,index){return _c('StickerMemo',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMemo),expression:"showMemo"}],key:memo.id || memo.index,attrs:{"index":index,"memoConfig":memo,"hasMaxCount":_vm.hasMaxCount,"activeMemoUniqueKey":_vm.activeMemoUniqueKey,"showMemo":_vm.showMemo},on:{"deleteMemo":_vm.deleteMemoPopup,"copyMemo":_vm.copyMemo,"saveMemo":_vm.saveMemo,"addMemo":_vm.addMemo,"activeMemo":_vm.activeMemo}})}),_vm._v(" "),_c('dialog-popup')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ed74e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 